import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "reply",
  "use": "reply-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"reply\">\n  <path d=\"M10,9 L10,5 L3,12 L10,19 L10,14.9 C15,14.9 18.5,16.5 21,20 C20,15 17,10 10,9 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol